import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Conditionally join Tailwind class names and merge conflicts.
 * @param  {...any} inputs
 * @returns {string}
 */
export function cn(...inputs) {
  return twMerge(clsx(...inputs));
}
